/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  PaymentCardsUserControllerFindManyQueryResponse,
  PaymentCardsUserControllerFindMany401,
} from '../../types/PaymentCardsUserControllerFindMany.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { paymentCardsUserFindMany } from '../../methods/paymentCardsUserFindMany.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const paymentCardsUserFindManyQueryKey = () => [{ url: '/api/user/payment-cards' }] as const;

export type PaymentCardsUserFindManyQueryKey = ReturnType<typeof paymentCardsUserFindManyQueryKey>;

export function paymentCardsUserFindManyQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = paymentCardsUserFindManyQueryKey();
  return queryOptions<
    PaymentCardsUserControllerFindManyQueryResponse,
    ResponseErrorConfig<PaymentCardsUserControllerFindMany401>,
    PaymentCardsUserControllerFindManyQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return paymentCardsUserFindMany(config);
    },
  });
}

/**
 * @summary List own saved cards, including expired cards
 * {@link /api/user/payment-cards}
 */
export function usePaymentCardsUserFindMany<
  TData = PaymentCardsUserControllerFindManyQueryResponse,
  TQueryData = PaymentCardsUserControllerFindManyQueryResponse,
  TQueryKey extends QueryKey = PaymentCardsUserFindManyQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        PaymentCardsUserControllerFindManyQueryResponse,
        ResponseErrorConfig<PaymentCardsUserControllerFindMany401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? paymentCardsUserFindManyQueryKey();

  const query = useQuery(
    {
      ...paymentCardsUserFindManyQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<PaymentCardsUserControllerFindMany401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
